/* ss-card-uso.js — su telefono non c'e' il passaggio del mouse: il bottone
   «In uso» sulla foto scambia tessuto e prodotto finito senza aprire la scheda.
   Un ascoltatore solo sul documento, cosi' vale anche per le card create dopo
   (Ci sta bene insieme). */
(function () {
  function scambia(flip) {
    var card = flip.closest('.ss-card');
    if (!card) return;
    var on = card.classList.toggle('is-uso');
    flip.textContent = on ? 'Tessuto' : 'In uso';
  }
  document.addEventListener('click', function (e) {
    var flip = e.target.closest && e.target.closest('[data-flip]');
    if (!flip) return;
    e.preventDefault();
    e.stopPropagation();
    scambia(flip);
  }, true);
})();
